import ResponsiveNav from 'responsive-nav';

const ready = () => {
  // initialize responsive nav on available nav bars
  const elements = document.querySelectorAll(
      '[data-function="navbar"][data-behavior="responsive"]'
    ),
    dispatch = (el, event) => {
      event = new Event(event);
      el.dispatchEvent(event);
    };
  let el;

  for (let i = 0; i < elements.length; i++) {
    let icon, label, toggle, togglePosition;

    el = elements[i];
    el.id = 'navbar_' + Math.floor(Math.random() * 100000);

    icon = el.getAttribute('data-icon')
      ? ' class="' + el.getAttribute('data-icon') + '"'
      : '';
    label = el.getAttribute('data-label')
      ? ' ' + el.getAttribute('data-label').trim()
      : '';
    toggle = el.getAttribute('data-toggle')
      ? el.getAttribute('data-toggle').trim()
      : '';
    togglePosition = el.getAttribute('data-toggle-position')
      ? el.getAttribute('data-toggle-position').trim()
      : '';
    ResponsiveNav(el.id, {
      label: '<i' + icon + '></i>' + label,
      customToggle: toggle,
      insert: togglePosition,
      open: dispatch.bind(this, el, 'open'),
      close: dispatch.bind(this, el, 'close'),
    });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ready);
} else {
  ready();
}
